import { useEffect, useState } from 'react';

function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false;
}

// Animates a number from `from` up to `target` over `ms` once `start` is true (ease-out),
// the way the design's ticker and trust stats count up. Reduced motion jumps straight
// to the target. Returns the current value.
export function useCountUp(target: number | undefined, { start = true, from = 0, ms = 1300 } = {}): number {
  const [value, setValue] = useState(from);

  useEffect(() => {
    if (target === undefined || !start) return;
    if (prefersReducedMotion() || typeof requestAnimationFrame !== 'function') {
      setValue(target);
      return;
    }
    let raf = 0;
    const t0 = performance.now();
    const tick = (now: number) => {
      const p = Math.min(1, (now - t0) / ms);
      const eased = 1 - (1 - p) ** 3;
      setValue(Math.round(from + (target - from) * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, start, from, ms]);

  return value;
}
